module.exports = __webpack_public_path__ + "img/hero-doqueestamosfalando.2be5d8ea.jpg";